import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const ProductLabel = lazy(() => import('../Pages/ProductLabel'));

// Import CSS
import '../Assets/css/product.scss';

function ProductLabelRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/stock/products-label"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <ProductLabel history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default ProductLabelRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
